import { type ApplicationStatus as ApplicationStatusType } from '#imports'

export interface ActivityApplication extends ApiEntity {
  vacancyId: id
  userId?: id
  volunteerCenterId?: id
  firstName: string
  lastName: string
  fullName: string
  email: string
  phoneNumber?: string
  message?: string
  status: ApplicationStatusType
  vacancyTitle: string
  profileColor: string
}

export function useFetchApplications(query?: SearchParameters) {
  return useJsonApiFetch<ActivityApplication[]>('/api/v1/activity_applications', { query })
}

export function useFetchApplication(id: id) {
  return useJsonApiFetch<ActivityApplication>(`/api/v1/activity_applications/${id}`)
}

export async function createApplication(
  attributes: Partial<ActivityApplication>,
) {
  const { data } = await $api<JSONAPIResponse<ActivityApplication>>(
    '/api/v1/activity_applications',
    {
      method: 'POST',
      body: {
        data: {
          type: 'activity_application',
          attributes: attributes,
        },
      },
    },
  )

  return data.attributes
}
